import { render, staticRenderFns } from "./NoDataText.vue?vue&type=template&id=002707c0"
import script from "./NoDataText.vue?vue&type=script&lang=js"
export * from "./NoDataText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports